import { useCallback, useState } from 'react'
import styled from 'styled-components'

import { Button, Layout, Text } from '@loadsmart/miranda-react'
import { getToken } from '@loadsmart/miranda-react/dist/tokens'

import { useAnalytics } from 'core/analytics/useAnalytics'

import { SignUpDialog } from 'auth/ui/SignUpDialog'

import { ALL_TRACKING_PROVIDERS } from '../../../domain/Tracking'
import { formatTrackingMethodName } from '../../../presenters/preferredTrackingMethod'
import BackgroundImage from '../../assets/tracking-onboarding-banner-bg.svg'
import { getMethodIcon } from '../trackingIconsUtils'
import { useTrackingOnboardingContext } from './TrackingOnboardingContext'

const Wrapper = styled.div`
  border-radius: ${getToken('border-radius-m')};
  padding: ${getToken('spacing-6')};
  background-size: cover;
  background-position: center;
  background-image: url(${BackgroundImage});
`

const StyledBox = styled(Layout.Box)`
  background-color: rgba(${getToken('color-primary-20')}, ${getToken('opacity-20')});
`

export default function SignUpUserNotOnboardedBanner() {
  const { track } = useAnalytics()
  const { showSignupUserNotOnboardedBanner } = useTrackingOnboardingContext()
  const [isSignUpOpen, setIsSignUpOpen] = useState(false)

  const handleGetStarted = useCallback(() => {
    setIsSignUpOpen(true)
    track('Open sign up: Tracking sign up banner')
  }, [track])

  function handleCloseSignUp() {
    setIsSignUpOpen(false)
  }

  return showSignupUserNotOnboardedBanner ? (
    <Wrapper>
      <Layout.Group align="center" gap="spacing-10">
        <Layout.Stack style={{ maxWidth: '700px' }}>
          <Text variant="heading-md-bold" color="color-text-inverted">
            Sign up for our Carrier Platform and unlock your full tracking potential
          </Text>
          <Text variant="body-md" color="color-text-inverted">
            Create your account, choose your preferred tracking method and provide real-time
            tracking updates to your shippers with no effort.
          </Text>
          <Layout.Group>
            {ALL_TRACKING_PROVIDERS.map(trackingMethod => (
              <StyledBox borderRadius="border-radius-m" padding="spacing-3" key={trackingMethod}>
                <Layout.Group align="center" gap="spacing-2">
                  {getMethodIcon(trackingMethod, 'color-background-primary')}
                  <Text variant="body-md-bold" color="color-text-inverted">
                    {formatTrackingMethodName(trackingMethod)}
                  </Text>
                </Layout.Group>
              </StyledBox>
            ))}
          </Layout.Group>
        </Layout.Stack>
        <Button
          variant="primary"
          size="large"
          style={{ marginLeft: 'auto' }}
          onClick={handleGetStarted}
        >
          Get started now
        </Button>
      </Layout.Group>
      {isSignUpOpen && (
        <SignUpDialog
          onCancel={handleCloseSignUp}
          onComplete={handleCloseSignUp}
          context="tracking-onboarding-signup-banner"
        />
      )}
    </Wrapper>
  ) : null
}
